// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/NewsArticle/article.sass
// module id = 542
// module chunks = 0